// Generate dynamic ticks for Y-axis
export const generateTicks = (
  domain: number[],
  step: number,
  importantValues: number[] = []
): number[] => {
  const [min, max] = domain;
  const ticks: number[] = [];

  for (let i = Math.ceil(min / step) * step; i <= max; i += step) {
    ticks.push(i);
  }

  // Add specific important values
  importantValues.forEach((val) => {
    if (val >= min && val <= max && !ticks.includes(val)) {
      ticks.push(val);
    }
  });

  return ticks.sort((a, b) => a - b);
};

// Calculate dynamic Y-axis domain with padding
export const calculateDomain = (
  values: number[],
  minDefault: number,
  maxDefault: number,
  stepSize: number = 10
): [number, number] => {
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);

  return [
    Math.min(minDefault, Math.floor(minValue / stepSize) * stepSize - stepSize),
    Math.max(maxDefault, Math.ceil(maxValue / stepSize) * stepSize + stepSize),
  ];
};
